<script lang="ts">
    import { DeliveryListSettingsApi, type UniqueSpecialClientAttributesType } from './DeliveryListSettingsApi';
    import { onMount } from 'svelte';
    import { api } from '../../../../stores/api';
    import MultiSelectWide from '../../../shared/MultiSelectWide.svelte';
    import IconPending from '../../../shared/Icons/IconPending.svelte';
    import SettingsRow from '../SettingsRow.svelte';
    import TemplateSettingsGeneral from '../TemplateSettingsGeneral.svelte';
    import { customerSettings } from '../../../../stores/api';
    import { _ } from 'svelte-i18n';

    let allAvailableKeys: UniqueSpecialClientAttributesType;

    export let update: () => void;

    let selectedClientKeys: string[] | null = null;
    let availableClientKeys: { id: string; name: string; }[] | null = null;

    let selectedSpecialKeys: string[] | null = null;
    let availableSpecialKeys: { id: string; name: string; }[] | null;

    function handleChangeClientAttributes(selectedKeys: string[]) {
        // let excludedKeys = allAvailableKeys?.unique_client_attributes?.filter(key => !selectedKeys.includes(key));
        $customerSettings.export.delivery_list = {
            ...$customerSettings.export.delivery_list,
            included_client_attributes: selectedKeys,
        };
        update();
        return true;
    }

    function handleChangeSpecialAttributes(selectedKeys: string[]) {
        // let excludedKeys = allAvailableKeys?.unique_special_attributes?.filter(key => !selectedKeys.includes(key));
        $customerSettings.export.delivery_list = {
            ...$customerSettings.export.delivery_list,
            included_special_attributes: selectedKeys,
        };
        update();
        return true;
    }

    onMount(() => {
        DeliveryListSettingsApi.getUniqueSpecialClientAttributes($api).then((attributes) => {

            // remove duplicates from attributes.unique_client_attributes and attributes.unique_special_attributes
            attributes.unique_client_attributes = Array.from(new Set(attributes.unique_client_attributes));
            attributes.unique_special_attributes = Array.from(new Set(attributes.unique_special_attributes));

            console.log('Unique special client attributes:', attributes);
            allAvailableKeys = attributes;

            // get from allAvailableKeys the selected keys that are not in included_client_attributes
            // selectedClientKeys = allAvailableKeys?.unique_client_attributes?.filter(key =>
            //     !($clientSettings.export.delivery_list.included_client_attributes ?? []).includes(key),
            // );
            selectedClientKeys = $customerSettings.export.delivery_list.included_client_attributes ?? [];
            console.log('Selected client keys:', selectedClientKeys);

            availableClientKeys = allAvailableKeys?.unique_client_attributes.map(key => ({
                id: key,
                name: key,
            }));
            console.log('Available client keys:', availableClientKeys);

            // selectedSpecialKeys = allAvailableKeys?.unique_special_attributes?.filter(key =>
            //     !($clientSettings.export.delivery_list.included_special_attributes ?? []).includes(key),
            // );
            selectedSpecialKeys = $customerSettings.export.delivery_list.included_special_attributes ?? [];
            console.log('Selected special keys:', selectedSpecialKeys);

            availableSpecialKeys = allAvailableKeys?.unique_special_attributes.map(key => ({
                id: key,
                name: key,
            }));
            console.log('Available special keys:', availableSpecialKeys);
        });
    });

</script>

<TemplateSettingsGeneral>
    <div slot="label">{$_('loading_list_display_values')}</div>
    <div slot="content">
        <SettingsRow>
            {#if selectedSpecialKeys && availableSpecialKeys}
                <div class="center-aligned-content">
                    <MultiSelectWide
                        availableEntries={availableSpecialKeys ?? []}
                        selectedIds={selectedSpecialKeys}
                        disabled={false}
                        minAllowedSelectedItems={0}
                        onChange={selectedIds => {
                                console.log('MultiSelectWide onChange', selectedIds);
                                handleChangeSpecialAttributes(selectedIds);
                            }}
                    />
                </div>
            {:else}
                <div>
                    <IconPending scale={0.7} spin={true} />
                </div>
            {/if}
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>
<TemplateSettingsGeneral>
    <div slot="label">{$_('import_file_display_values')}</div>
    <div slot="content">
        {#if selectedClientKeys && availableClientKeys}
            <div class="center-aligned-content">
                <MultiSelectWide
                    availableEntries={availableClientKeys ?? []}
                    selectedIds={selectedClientKeys}
                    disabled={false}
                    minAllowedSelectedItems={0}
                    onChange={selectedIds => {
                                console.log('MultiSelectWide onChange', selectedIds);
                                handleChangeClientAttributes(selectedIds);
                            }}
                />
            </div>
        {:else}
            <div>
                <IconPending scale={0.7} spin={true} />
            </div>
        {/if}
    </div>
</TemplateSettingsGeneral>


<style>
    :global(.multi-select-wide-container) {
        background-color: transparent !important;
    }
    .center-aligned-content {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
</style>